import { createUseStyles } from 'react-jss'
import { style as iframeReportStyle } from './iframe-report.style'

const { iframe, iframeFullHeight } = iframeReportStyle

export const style = {
  subfolderInputSection: {
    composes: 'flex-column flex-center-items',
    marginTop: 40
  },
  viewSubfolderButton: {
    marginLeft: 20,
    height: 42
  },
  iframe,
  iframeFullHeight
}

export const useStyles = createUseStyles(style)
